export class EmitEvent {
  constructor(public name: string, public value?: unknown) {}
}
